import { API } from "../urls";

const getHeaders = () => ({
    "Content-Type": "application/json",
});

const fetchOpts = { credentials: 'include' };

// Mevcut kullanıcı bilgisi
export const fetchAuthMe = async () => {
    const res = await fetch(API.auth_me, { ...fetchOpts, headers: getHeaders() });
    return res;
};

// Çıkış yap
export const logout = async () => {
    const res = await fetch(API.logout, { method: 'POST', ...fetchOpts });
    return res;
};

// Kullanıcı değiştirmeden geri dön
export const switchBack = async () => {
    const res = await fetch(API.switch_back, { method: 'POST', ...fetchOpts });
    return res;
};

// Token yenile
export const refreshToken = async () => {
    const res = await fetch(API.refresh_token, {
        method: 'POST',
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify({}),
    });
    return res;
};

// Profil güncelle
export const updateProfile = async (payload) => {
    const res = await fetch(API.profile_update_me, {
        method: "PATCH",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    return res;
};
